import axios from "axios";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import moment from "moment";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";
import DatePicker from "react-datepicker";
import * as Icons from "react-feather";

const TaskingCommentHistory = forwardRef(({ data, onNextFollowupUpdate, showFollowupTab }, ref) => {
  const [getTaskingHistory, setTaskingHistory] = useState([]);
  const [getTaskingComments, setTaskingComments] = useState([]);
  const [alert, setAlert] = useState(null);
  const [showCommentsButtons, setShowCommentsButtons] = useState(false);
  const [showFollowupButtons, setshowFollowupButtons] = useState(false);
  const [textComments, setTextComments] = useState("");
  const [descriptionText, setDescriptionText] = useState("");
  const [showDescriptionButtons, setShowDescriptionButtons] = useState(false);
  const [descriptionSaving, setDescriptionSaving] = useState(false);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingCommentText, setEditingCommentText] = useState("");
  const [commentSaving, setCommentSaving] = useState(false);
  const [hoveredCommentId, setHoveredCommentId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState({
    show: false,
    commentId: null,
    commentText: "",
    commentUser: "",
  });
  const [editingFollowupId, setEditingFollowupId] = useState(null);
  const [editingFollowupText, setEditingFollowupText] = useState("");
  const [editingFollowupDate, setEditingFollowupDate] = useState(null);
  const [followupSaving, setFollowupSaving] = useState(false);
  const [hoveredFollowupId, setHoveredFollowupId] = useState(null);
  const [deleteFollowupConfirm, setDeleteFollowupConfirm] = useState({
    show: false,
    followupId: null,
    followupText: "",
    followupUser: "",
    followupDate: "",
  });
  const [activeTab, setActiveTab] = useState("Comments");
  const currentUserId = Number(getStorageValues("userId"));
  const [getTaskingFollowup, setTaskingFollowup] = useState([]);
  const [followupDate, setFollowupDate] = useState(new Date());
  const [followupRemarks, setFollowupRemarks] = useState("");
  useEffect(() => {
    if (showFollowupTab) {
      setActiveTab("Followup");
    }
  }, [showFollowupTab]);
  useImperativeHandle(ref, () => ({
    refreshHistory: fetchTaskingHistory,
  }));

  const fetchTaskingFollowup = async () => {
    try {
      let followupDetails = {
        UserId: getStorageValues("userId"),
        TaskId: data.TaskId,
      };
      const response = await axios.get(
        getApiBaseUrl() + "/getTaskingFollowupByTaskId",
        { params: followupDetails }
      );
      if (response.status === 200) {
        setTaskingFollowup(response.data.data[0]);
      }
    } catch (error) {
      CreateAlert("Problem loading follow-up!", "Error", setAlert);
      console.log(error);
    }
  };

  async function handleSaveFollowup() {
    let followupDetails = {
      UserId: getStorageValues("userId"),
      TaskId: data.TaskId,
      FollowupDate: moment(followupDate).format("YYYY-MM-DD HH:mm:ss"),
      FollowupRemarks: followupRemarks,
    };
    try {
      const response = await axios.post(
        getApiBaseUrl() + "/saveTaskingFollowup",
        followupDetails
      );
      if (response.status === 200) {
        setFollowupRemarks("");
        fetchTaskingFollowup();
      }
    } catch (error) {
      console.log(error);
    }
  }
  const fetchTaskingHistory = async () => {
    try {
      let historyDetails = {
        UserId: getStorageValues("userId"),
        TaskId: data.TaskId,
      };
      const response = await axios.get(getApiBaseUrl() + "/getTaskingHistory", {
        params: historyDetails,
      });
      if (response.status === 200) {
        setTaskingHistory(response.data.data[0]);
      }
    } catch (error) {
      CreateAlert("Some Problem loading History!!", "Error", setAlert);
      console.log(error);
    }
  };

  const fetchTaskingComments = async () => {
    try {
      let CommentsDetails = {
        UserId: getStorageValues("userId"),
        TaskId: data.TaskId,
      };
      const response = await axios.get(
        getApiBaseUrl() + "/getTaskingCommentsByTaskId",
        { params: CommentsDetails }
      );
      if (response.status === 200) {
        setTaskingComments(response.data.data[0]);
      }
    } catch (error) {
      CreateAlert("Some Problem loading History!!", "Error", setAlert);
      console.log(error);
    }
  };

  function handleChange(e) {
    if ((e.currentTarget.name = "Comments")) {
      setTextComments(e.currentTarget.value);
    } else {
      setFollowupRemarks(e.currentTarget.value);
    }
  }
  async function handleSave() {
    let commentsDetails = {
      UserId: getStorageValues("userId"),
      TaskId: data.TaskId,
      Comments: textComments,
    };
    try {
      const response = await axios.post(
        getApiBaseUrl() + "/saveTaskingComments",
        commentsDetails
      );
      if (response.status === 200) {
        console.log("comments added successfully!!");
        setTextComments("");
        fetchTaskingComments();
      }
    } catch (error) {
      console.log(error);
    }
  }
  function handleCancel(e) {
    setShowCommentsButtons(false);
    setshowFollowupButtons(false);
    setTextComments("");
  }

  const stripHtml = (value = "") => value.replace(/<[^>]+>/g, "");

  const startEditComment = (comment) => {
    setEditingCommentId(comment?.TaskingCommentId || null);
    setEditingCommentText(stripHtml(comment?.Comments || ""));
  };

  const cancelEditComment = () => {
    setEditingCommentId(null);
    setEditingCommentText("");
  };

  const saveEditedComment = async () => {
    if (!editingCommentId) return;
    if (!editingCommentText.trim()) {
      CreateAlert("Comments cannot be empty", "Warning", setAlert);
      return;
    }
    setCommentSaving(true);
    try {
      const payload = {
        UserId: getStorageValues("userId"),
        TaskingCommentId: editingCommentId,
        Comments: editingCommentText
      };
      const response = await axios.post(
        getApiBaseUrl() + "/updateTaskingComments",
        payload
      );
      if (response.status === 200) {
        CreateAlert("Comments updated successfully!!", "Success", setAlert);
        cancelEditComment();
        fetchTaskingComments();
      }
    } catch (error) {
      console.log(error);
      CreateAlert("Problem updating comments!!", "Error", setAlert);
    } finally {
      setCommentSaving(false);
    }
  };

  const openDeleteConfirm = (comment) => {
    setDeleteConfirm({
      show: true,
      commentId: comment?.TaskingCommentId || null,
      commentText: stripHtml(comment?.Comments || ""),
      commentUser: comment?.FullName || "",
    });
  };

  const closeDeleteConfirm = () => {
    setDeleteConfirm({ show: false, commentId: null, commentText: "", commentUser: "" });
  };

  const deleteComment = async (commentId) => {
    if (!commentId) return;
    try {
      const payload = {
        UserId: getStorageValues("userId"),
        TaskingCommentId: commentId
      };
      const response = await axios.post(
        getApiBaseUrl() + "/deleteTaskingComments",
        payload
      );
      if (response.status === 200) {
        CreateAlert("Comments deleted successfully!!", "Success", setAlert);
        fetchTaskingComments();
        closeDeleteConfirm();
      }
    } catch (error) {
      console.log(error);
      CreateAlert("Problem deleting comments!!", "Error", setAlert);
    }
  };

  const confirmDeleteComment = () => {
    if (deleteConfirm.commentId) {
      deleteComment(deleteConfirm.commentId);
    }
  };

  const startEditFollowup = (followup) => {
    setEditingFollowupId(followup?.TaskingFollowupId || null);
    setEditingFollowupText(
      stripHtml(followup?.FollowupRemarksText || followup?.FollowupRemarks || "")
    );
    setEditingFollowupDate(
      followup?.FollowupDate ? new Date(followup.FollowupDate) : new Date()
    );
  };

  const cancelEditFollowup = () => {
    setEditingFollowupId(null);
    setEditingFollowupText("");
    setEditingFollowupDate(null);
  };

  const saveEditedFollowup = async () => {
    if (!editingFollowupId) return;
    if (!editingFollowupText.trim()) {
      CreateAlert("Follow-up remarks cannot be empty", "Warning", setAlert);
      return;
    }
    setFollowupSaving(true);
    try {
      const payload = {
        UserId: getStorageValues("userId"),
        TaskingFollowupId: editingFollowupId,
        FollowupRemarks: editingFollowupText,
        FollowupDate: editingFollowupDate
          ? moment(editingFollowupDate).format("YYYY-MM-DD HH:mm:ss")
          : null,
      };
      const response = await axios.post(
        getApiBaseUrl() + "/updateTaskingFollowup",
        payload
      );
      if (response.status === 200) {
        CreateAlert("Follow-up updated successfully!!", "Success", setAlert);
        if (onNextFollowupUpdate && editingFollowupDate) {
          onNextFollowupUpdate(
            data.TaskId,
            moment(editingFollowupDate).format("YYYY-MM-DD HH:mm:ss")
          );
        }
        cancelEditFollowup();
        fetchTaskingFollowup();
      }
    } catch (error) {
      console.log(error);
      CreateAlert("Problem updating follow-up!!", "Error", setAlert);
    } finally {
      setFollowupSaving(false);
    }
  };

  const openDeleteFollowupConfirm = (followup) => {
    setDeleteFollowupConfirm({
      show: true,
      followupId: followup?.TaskingFollowupId || null,
      followupText: stripHtml(
        followup?.FollowupRemarksText || followup?.FollowupRemarks || ""
      ),
      followupUser: followup?.FullName || "",
      followupDate: followup?.FollowupDate || "",
    });
  };

  const closeDeleteFollowupConfirm = () => {
    setDeleteFollowupConfirm({
      show: false,
      followupId: null,
      followupText: "",
      followupUser: "",
      followupDate: "",
    });
  };

  const deleteFollowup = async (followupId) => {
    if (!followupId) return;
    try {
      const payload = {
        UserId: getStorageValues("userId"),
        TaskingFollowupId: followupId,
      };
      const response = await axios.post(
        getApiBaseUrl() + "/deleteTaskingFollowup",
        payload
      );
      if (response.status === 200) {
        CreateAlert("Follow-up deleted successfully!!", "Success", setAlert);
        fetchTaskingFollowup();
        closeDeleteFollowupConfirm();
      }
    } catch (error) {
      console.log(error);
      CreateAlert("Problem deleting follow-up!!", "Error", setAlert);
    }
  };

  const confirmDeleteFollowup = () => {
    if (deleteFollowupConfirm.followupId) {
      deleteFollowup(deleteFollowupConfirm.followupId);
    }
  };
  const handleCommentsFocus = () => {
    setShowCommentsButtons(true);
    setshowFollowupButtons(false);
  };

  const handleFollowupFocus = () => {
    setshowFollowupButtons(true);
    setShowCommentsButtons(false);
  };

  const handleDescriptionFocus = () => {
    setShowDescriptionButtons(true);
    setshowFollowupButtons(false);
    setShowCommentsButtons(false);
  };

  const saveDescription = async () => {
    if (!data?.TaskId) return;
    setDescriptionSaving(true);
    try {
      const payload = {
        UserID: getStorageValues("userId"),
        TaskId: data.TaskId,
        FieldId: 0,
        Description: descriptionText,
        UpdateField: "Description",
      };
      const response = await axios.post(getApiBaseUrl() + "/updateTask", payload);
      if (response.status === 200) {
        CreateAlert("Description updated successfully!!", "Success", setAlert);
        fetchTaskingHistory();
        setShowDescriptionButtons(false);
      }
    } catch (error) {
      console.log(error);
      CreateAlert("Problem updating description!!", "Error", setAlert);
    } finally {
      setDescriptionSaving(false);
    }
  };

  function changeTimeDiff() {
    // Placeholder for time diff toggle UI (currently not used)
  }
  const renderComments = getTaskingComments.map((obj, index) => {
    const isOwner = Number(obj?.CreatedBy) === currentUserId;
    return (
      <div className="col-xl-12" key={obj.TaskingCommentId || index}>
        <div
          className="card card-bg-light mg-em"
          key={obj.TaskingCommentId || index}
        >
          <div
            className="card-body position-relative"
            onMouseEnter={() => setHoveredCommentId(obj.TaskingCommentId)}
            onMouseLeave={() => setHoveredCommentId(null)}
          >
            {isOwner && editingCommentId !== obj.TaskingCommentId && (
              <>
                <div
                  className="d-flex d-md-none align-items-center gap-2"
                  style={{ position: "absolute", top: "10px", right: "10px" }}
                >
                  <span
                    role="button"
                    title="Edit"
                    className="text-info"
                    style={{ cursor: "pointer" }}
                    onClick={() => startEditComment(obj)}
                  >
                    <Icons.Edit size={16} className="feather-edit" />
                  </span>
                  <span
                    role="button"
                    title="Delete"
                    className="text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={() => openDeleteConfirm(obj)}
                  >
                    <Icons.Trash2 size={16} className="feather-trash-2" />
                  </span>
                </div>
                {hoveredCommentId === obj.TaskingCommentId && (
                  <div
                    className="d-none d-md-flex align-items-center gap-2"
                    style={{ position: "absolute", top: "10px", right: "10px" }}
                  >
                    <span
                      role="button"
                      title="Edit"
                      className="text-info"
                      style={{ cursor: "pointer" }}
                      onClick={() => startEditComment(obj)}
                    >
                      <Icons.Edit size={16} className="feather-edit" />
                    </span>
                    <span
                      role="button"
                      title="Delete"
                      className="text-danger"
                      style={{ cursor: "pointer" }}
                      onClick={() => openDeleteConfirm(obj)}
                    >
                      <Icons.Trash2 size={16} className="feather-trash-2" />
                    </span>
                  </div>
                )}
              </>
            )}
            <div className="d-flex align-items-center w-100 pd-15">
              <div className="me-2">
                <span className="avatar avatar-rounded">
                  <img
                    alt=""
                    src={"/assets/img/profiles/" + obj.CreateByUserImagePath}
                  />
                </span>
              </div>
              <div className="flex-grow-1">
                <div className="fs-15 fw-semibold">{obj.FullName}</div>
                <div className="fs-15 fw-semibold1">
                  {editingCommentId === obj.TaskingCommentId ? (
                    <div>
                      <textarea
                        className="form-control w-100"
                        rows="2"
                        value={editingCommentText}
                        onChange={(e) => setEditingCommentText(e.target.value)}
                      />
                      <div className="mt-2">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm py-1 px-2 me-2"
                          onClick={saveEditedComment}
                          disabled={commentSaving}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm py-1 px-2"
                          onClick={cancelEditComment}
                          disabled={commentSaving}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      role={isOwner ? "button" : undefined}
                      style={{ cursor: isOwner ? 'pointer' : 'default', opacity: isOwner ? 1 : 0.9 }}
                      onClick={() => {
                        if (isOwner) startEditComment(obj);
                      }}
                      dangerouslySetInnerHTML={{ __html: obj.Comments }}
                    ></div>
                  )}
                  
                </div>
                <p className="mb-0 text-muted op-7 fs-12">
                  <span
                    onClick={() => changeTimeDiff(obj.TaskingCommentId)}
                    className="notification-time"
                  >
                    {moment(obj.CreatedDate).format("MM/DD/YYYY, h:mm A")}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  });

  const renderFollowup = getTaskingFollowup.map((obj, index) => {
    const isOwner = Number(obj?.CreatedBy) === currentUserId;
    return (
      <div className="col-xl-12" key={obj.TaskingFollowupId || index}>
        <div
          className="card card-bg-light mg-em"
          key={obj.TaskingFollowupId || index}
        >
          <div
            className="card-body position-relative"
            onMouseEnter={() => setHoveredFollowupId(obj.TaskingFollowupId)}
            onMouseLeave={() => setHoveredFollowupId(null)}
          >
            {isOwner && editingFollowupId !== obj.TaskingFollowupId && (
              <>
                <div
                  className="d-flex d-md-none align-items-center gap-2"
                  style={{ position: "absolute", top: "10px", right: "10px" }}
                >
                  <span
                    role="button"
                    title="Edit"
                    className="text-info"
                    style={{ cursor: "pointer" }}
                    onClick={() => startEditFollowup(obj)}
                  >
                    <Icons.Edit size={16} className="feather-edit" />
                  </span>
                  <span
                    role="button"
                    title="Delete"
                    className="text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={() => openDeleteFollowupConfirm(obj)}
                  >
                    <Icons.Trash2 size={16} className="feather-trash-2" />
                  </span>
                </div>
                {hoveredFollowupId === obj.TaskingFollowupId && (
                  <div
                    className="d-none d-md-flex align-items-center gap-2"
                    style={{ position: "absolute", top: "10px", right: "10px" }}
                  >
                    <span
                      role="button"
                      title="Edit"
                      className="text-info"
                      style={{ cursor: "pointer" }}
                      onClick={() => startEditFollowup(obj)}
                    >
                      <Icons.Edit size={16} className="feather-edit" />
                    </span>
                    <span
                      role="button"
                      title="Delete"
                      className="text-danger"
                      style={{ cursor: "pointer" }}
                      onClick={() => openDeleteFollowupConfirm(obj)}
                    >
                      <Icons.Trash2 size={16} className="feather-trash-2" />
                    </span>
                  </div>
                )}
              </>
            )}
            <div className="d-flex align-items-center w-100 pd-15">
              <div className="me-2">
                <span className="avatar avatar-rounded">
                  <img
                    alt=""
                    src={"/assets/img/profiles/" + obj.UserImagePath}
                  />
                </span>
              </div>
              <div className="flex-grow-1">
                <div className="fs-15 fw-semibold">{obj.FullName}</div>
                <div className="fs-15 fw-semibold1">
                  {editingFollowupId === obj.TaskingFollowupId ? (
                    <div>
                      <div className="row g-2">
                        <div className="col-12 col-md-2">
                          <label className="form-label mb-1" style={{ fontSize: '12px' }}>Follow-up Date</label>
                          <DatePicker
                            className="form-control form-control-sm"
                            selected={editingFollowupDate}
                            onChange={(date) => setEditingFollowupDate(date)}
                            dateFormat="dd/MM/yyyy"
                          />
                        </div>
                        <div className="col-12 col-md-10">
                          <label className="form-label mb-1" style={{ fontSize: '12px' }}>Remarks</label>
                          <textarea
                            className="form-control w-100"
                            rows="1"
                            value={editingFollowupText}
                            onChange={(e) => setEditingFollowupText(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="mt-2">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm py-1 px-2 me-2"
                          onClick={saveEditedFollowup}
                          disabled={followupSaving}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm py-1 px-2"
                          onClick={cancelEditFollowup}
                          disabled={followupSaving}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      role={isOwner ? "button" : undefined}
                      style={{ cursor: isOwner ? "pointer" : "default", opacity: isOwner ? 1 : 0.9 }}
                      onClick={() => {
                        if (isOwner) startEditFollowup(obj);
                      }}
                      dangerouslySetInnerHTML={{ __html: obj.FollowupRemarks }}
                    ></div>
                  )}
                </div>
                <p className="mb-0 text-muted op-7 fs-12">
                  <span
                    onClick={() => changeTimeDiff(obj.TaskingFollowupId)}
                    className="notification-time"
                  >
                    {moment(obj.CreatedDate).format("MM/DD/YYYY, h:mm A")}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  });

  const renderHistory = getTaskingHistory.map((obj, index) => {
    return (
      <div
        className="card card-bg-light mg-em"
        key={obj.TaskingHistoryId || index}
      >
        <div className="card-body">
          <div className="d-flex align-items-center w-100 pd-15 row">
            <div className="col-lg-10 col-sm-10 col-10">
              <div className="mb-32">
                <div className="fs-15 fw-semibold1">
                  <div
                    dangerouslySetInnerHTML={{ __html: obj.HistoryText }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-sm-2 col-2">
              <div className="mb-311 tl-r">
                <span
                  onClick={() => changeTimeDiff(obj.TaskingHistoryId)}
                  className="notification-time"
                >
                  {moment(obj.CreatedDate).format("MM/DD/YYYY, h:mm A")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  });
  useEffect(() => {
    fetchTaskingHistory();
    fetchTaskingComments();
    fetchTaskingFollowup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDescriptionText(stripHtml(data?.Description || ""));
  }, [data?.Description]);

  return (
    <>
      <SKAlerts alert={alert} />

      <div className="card-body tasking-comment-history">
        <ul
          className="nav nav-pills justify-content-left nav-style-2 mb-3"
          role="tablist"
        >
          {/* Comments */}
          <li key="Comments" className="nav-item" role="presentation">
            <a
              className={"nav-link" + (activeTab === "Comments" ? " active" : "")}
              data-bs-toggle="tab"
              href={"#Comments" + data.TaskKey}
              role="tab"
              aria-selected={activeTab === "Comments"}
              onClick={() => setActiveTab("Comments")}
            >
              Comments
            </a>
          </li>

          {/* Followup */}
          <li key="Followup" className="nav-item" role="presentation">
            <a
              className={"nav-link" + (activeTab === "Followup" ? " active" : "")}
              data-bs-toggle="tab"
              href={"#Followup" + data.TaskKey}
              role="tab"
              aria-selected={activeTab === "Followup"}
              onClick={() => setActiveTab("Followup")}
            >
              Follow Up
            </a>
          </li>

          {/* Description */}
          <li key="Description" className="nav-item" role="presentation">
            <a
              className={"nav-link" + (activeTab === "Description" ? " active" : "")}
              data-bs-toggle="tab"
              href={"#Description" + data.TaskKey}
              role="tab"
              aria-selected={activeTab === "Description"}
              onClick={() => setActiveTab("Description")}
            >
              Description
            </a>
          </li>

          {/* History */}
          <li key="History" className="nav-item" role="presentation">
            <a
              className={"nav-link" + (activeTab === "History" ? " active" : "")}
              data-bs-toggle="tab"
              href={"#History" + data.TaskKey}
              role="tab"
              aria-selected={activeTab === "History"}
              onClick={() => setActiveTab("History")}
            >
              History
            </a>
          </li>
        </ul>

        <div className="tab-content">
          {/* Comments Tab */}
          <div
            className={"tab-pane fade" + (activeTab === "Comments" ? " active show" : "")}
            id={"Comments" + data.TaskKey}
            role="tabpanel"
          >
            <div className="row">
              <div className="col-xl-12">
                <textarea
                  value={textComments}
                  className="form-control h-100"
                  rows="3"
                  name="Comments"
                  onChange={handleChange}
                  onFocus={handleCommentsFocus}
                  placeholder="type here to add comments"
                />
              </div>
              <div
                className="col-xl-12 mt-1"
                style={{ display: showCommentsButtons ? "block" : "none" }}
              >
                <button
                  type="button"
                  className="btn btn-primary btn-sm py-1 px-2 me-2"
                  onClick={handleSave}
                >
                  save
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm py-1 px-2"
                  onClick={handleCancel}
                >
                  cancel
                </button>
              </div>
              <div className="col-xl-12">
                <div className="scrollable-comments">{renderComments}</div>
              </div>
            </div>
          </div>

          {/* Followup Tab */}
          <div
            className={"tab-pane fade" + (activeTab === "Followup" ? " active show" : "")}
            id={"Followup" + data.TaskKey}
            role="tabpanel"
          >
            <div className="row">
              <div className="col-lg-2 col-sm-6 col-12">
                <div className="input-blocks">
                  <label className="form-label followup-label">Follow Up Date</label>
                  <div className="input-groupicon calender-input">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-calendar info-img"
                    >
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                      ></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <DatePicker
                      className="datetimepicker"
                      selected={followupDate}
                      onChange={(date) => setFollowupDate(date)}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      disabledKeyboardNavigation
                      minDate={new Date()}
                    />
                  </div>
                </div>
              </div>

              <div className="col-xl-10">
                <label className="form-label">Add Follow-up Remark</label>
                <textarea
                  value={followupRemarks}
                  className="form-control"
                  rows="1"
                  name="FollowupRemarks"
                  onChange={(e) => setFollowupRemarks(e.target.value)}
                  onFocus={handleFollowupFocus}
                  placeholder="Type here to add Follow-up Remark"
                />
                <div
                  className="mt-1"
                  style={{ display: showFollowupButtons ? "block" : "none" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary btn-sm py-1 px-2 me-2"
                    onClick={handleSaveFollowup}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm py-1 px-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="scrollable-comments">{renderFollowup}</div>
              </div>
            </div>
          </div>

          {/* Description Tab */}
          <div
            className={"tab-pane fade" + (activeTab === "Description" ? " active show" : "")}
            id={"Description" + data.TaskKey}
            role="tabpanel"
          >
            <div className="row">
              <div className="col-xl-12">
                <label className="form-label">Description</label>
                <textarea
                  value={descriptionText}
                  className="form-control"
                  rows="4"
                  name="Description"
                  onChange={(e) => setDescriptionText(e.target.value)}
                  onFocus={handleDescriptionFocus}
                  placeholder="Type description here"
                />
              </div>
              <div
                className="col-xl-12 mt-1"
                style={{ display: showDescriptionButtons ? "block" : "none" }}
              >
                <button
                  type="button"
                  className="btn btn-primary btn-sm py-1 px-2 me-2"
                  onClick={saveDescription}
                  disabled={descriptionSaving}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm py-1 px-2"
                  onClick={() => {
                    setDescriptionText(stripHtml(data?.Description || ""));
                    setShowDescriptionButtons(false);
                  }}
                  disabled={descriptionSaving}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>

          {/* History Tab */}
          <div
            className={"tab-pane fade" + (activeTab === "History" ? " active show" : "")}
            id={"History" + data.TaskKey}
            role="tabpanel"
          >
            <div className="scrollable-history-comments">{renderHistory}</div>
          </div>
        </div>
      </div>

      <Modal
        show={deleteConfirm.show}
        onHide={closeDeleteConfirm}
        backdrop="static"
      >
        <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
          <ModalTitle>
            <div className="custom-alert-icon">
              <Icons.AlertOctagon className="flex-shrink-0" />
            </div>
            <div>Delete Comment</div>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div className="text-left px-2 pb-0">
            <h6>Following comment will be deleted and could not be recovered!!</h6>
            <ul>
              <li><b>User :</b> {deleteConfirm.commentUser || "-"}</li>
              <li><b>Comment :</b> {deleteConfirm.commentText || "-"}</li>
            </ul>
          </div>
        </ModalBody>
        <ModalFooter className="modalfooter-width">
          <button
            className="btn btn-sm btn-secondary m-1"
            type="button"
            onClick={closeDeleteConfirm}
          >
            Cancel
          </button>
          <button
            className="btn btn-sm btn-danger m-1"
            type="button"
            onClick={confirmDeleteComment}
          >
            Delete
          </button>
        </ModalFooter>
      </Modal>

      <Modal
        show={deleteFollowupConfirm.show}
        onHide={closeDeleteFollowupConfirm}
        backdrop="static"
      >
        <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
          <ModalTitle>
            <div className="custom-alert-icon">
              <Icons.AlertOctagon className="flex-shrink-0" />
            </div>
            <div>Delete Follow-up</div>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div className="text-left px-2 pb-0">
            <h6>Following follow-up will be deleted and could not be recovered!!</h6>
            <ul>
              <li><b>User :</b> {deleteFollowupConfirm.followupUser || "-"}</li>
              <li><b>Date :</b> {deleteFollowupConfirm.followupDate ? moment(deleteFollowupConfirm.followupDate).format("MM/DD/YYYY") : "-"}</li>
              <li><b>Follow-up :</b> {deleteFollowupConfirm.followupText || "-"}</li>
            </ul>
          </div>
        </ModalBody>
        <ModalFooter className="modalfooter-width">
          <button
            className="btn btn-sm btn-secondary m-1"
            type="button"
            onClick={closeDeleteFollowupConfirm}
          >
            Cancel
          </button>
          <button
            className="btn btn-sm btn-danger m-1"
            type="button"
            onClick={confirmDeleteFollowup}
          >
            Delete
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
});

export default TaskingCommentHistory;
